import { render } from "./NewUserCT.vue?vue&type=template&id=ef89f132"
import script from "./NewUserCT.vue?vue&type=script&lang=js"
export * from "./NewUserCT.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__